import AmountOffProductsPricing from './AmountOffProductsPricing'
import PurchaseConditions from '../AmountOff/PurchaseConditions'
import MaxUsesPerOrder from '../../../MaxUsesPerOrder'

const DiscountApplicationRulesAmountOffProducts = () => {
  return (
    <div className='flex flex-col gap-4'>
      <AmountOffProductsPricing />
      <PurchaseConditions />
      <MaxUsesPerOrder />
    </div>
  )
}

export default DiscountApplicationRulesAmountOffProducts
